//
// 
//
rs.module("system_/configuration/portalrequests/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls) {
            var form = $.js(jsSelectors.form);

            // Update the grid when the include disabled filter is toggled
            form.js(jsSelectors.includeCancelledCheckbox).change(function () {
                form.js(jsSelectors.loadingSpinner).show();
                gridModule.update(
                    backendUrls.getRequestsAsync,
                    {
                        includeCancelled: $(this).is(":checked")
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        form.js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);